import { device } from "../Utils/device.js";
import { CHUNK_SIZE, MIN_Y, WORLD_SIZE } from "./terrain/constants.js";

const lodDesktop = [
    { scale: 1, enter: 3, leave: 4 },
    { scale: 2, enter: 6, leave: 7 },
    { scale: 4, enter: 10, leave: 11 },
    { scale: 8, enter: 64, leave: 64 },
];

const lodLow = [
    { scale: 1, enter: 2, leave: 3 },
    { scale: 2, enter: 4, leave: 5 },
    { scale: 4, enter: 7, leave: 8 },
    { scale: 8, enter: 64, leave: 64 },
];

export const CONFIG = {
    WORLD_SIZE,
    CHUNK_SIZE,
    MIN_Y,
    MAX_STEP: 1,
    WIN_DEPTH: 5,

    CAMERA_NEAR: 0.05,
    CAMERA_FAR: 1600,
    CAMERA_CLEARANCE: 1.5,

    PLAYER_SPEED: 500,
    TERRAIN_BOUNDARY_HEIGHT: 2,
    DIG_HEIGHT_TOLERANCE: 0.25,

    STORM_PERIOD: 30,
    STORM_DURATION: 10,
    STORM_DPS: 5,

    SAND_COUNT: device.isLowPower ? 2500 : 4500,
    DEBRIS_PER_DIG: device.isLowPower ? 7 : 12,
    SAND_SIZE: device.isLowPower ? 0.32 : 0.24,

    SAND_RANGE: 22,
    SAND_TOP: 30,

    LOD_RINGS: device.isLowPower ? lodLow : lodDesktop,
};

export function columnX(i) {
    return i - WORLD_SIZE / 2;
}

export function columnZ(j) {
    return j - WORLD_SIZE / 2;
}

export function columnFromX(x) {
    return Math.round(x + WORLD_SIZE / 2);
}

export function columnFromZ(z) {
    return Math.round(z + WORLD_SIZE / 2);
}

export function surfaceY(height) {
    return height + 0.5;
}
